// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__-gxko","titleContainer":"styles_titleContainer__pwevO","inputContainer":"styles_inputContainer__gQBTk"};